import { Component } from 'react';

import * as cs from 'css/CommonStyle';
import * as forms from 'css/forms';
import { FilledYellow } from 'css/Buttons'
import DropDownMenu from 'common/forms/DropDown'
import EmailPhoneToggle from 'authentication/components/EmailPhoneToggle'

import { InputWrap, ButtonWrap, OperatorWrapper } from 'admin/QueryStyles'

const metaSearchTypes = [
  {displayValue: "All Sites", key: "AllUsers"},
  {displayValue: "MGG Users", key: "MGGUsers"},
  {displayValue: "Alumni Users", key: "AlumniUsers"},
  {displayValue: "D12 Users", key: "D12Users"},
  {displayValue: "UCLA1 Users", key: "UCLA1Users"},
  {displayValue: "OLG Users", key: "OLGUsers"},
  {displayValue: "Anderson Users", key: "ANDUsers"},
  {displayValue: "ASC Users", key: "ASCUsers"},
  {displayValue: "UCLA Foundation", key: "UFUsers"},
  {displayValue: "Auctions", key: "Auctions"},
]

const searchTypes = [
  {displayValue: "CRM ID", key: "CrmId"},
  {displayValue: "Username", key: "CognitoUsername"},
  {displayValue: "Last Login", key: "LastLogin"},
  {displayValue: "Date Created", key: "DateCreated"},
  {displayValue: "Date Updated", key: "DateUpdated"},
  {displayValue: "Show All", key: "ShowAll"},
]

class SharedQueryForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      metaSearchDisplay: 'All Sites',
      metaSearchType: 'AllUsers',
      searchType: "CrmId",
      searchDisplay: "CRM ID",
      actionType: "LINK_USER",
      queryApp: 'All'
    }
  }

  componentDidMount() {
  }

  handleMetaDropdownChange = async e => {
    const metaSearchType = e.target.value.key;
    this.setState({
      metaSearchType,
      queryApp: metaSearchType.replace('Users',''),
      metaSearchDisplay: e.target.value.displayValue,
    });
  }

  handleSearchTypeChange = e => {
    const searchType = e.target.value.key;
    this.setState({
      searchType,
      searchDisplay: e.target.value.displayValue,
      searchFieldName: searchType + 'InputField', // give fields different names so browsers will remember the right things
      searchValue: '',
      searchDateTo: '',
      searchDateFrom: '',
    });
  }

  handleActionTypeChange = e => {
    this.setState({
      actionType: e.target.value,
      searchValue: e.target.value,
    });
  }

  handleSearchFieldChange = e => {
    this.setState({
      searchValue: '' + e.target.value,
    });
  }

  handleToDateFieldChange = e => {
    this.setState({
      searchDateTo: '' + e.target.value,
    });
  }

  handleFromDateFieldChange = e => {
    this.setState({
      searchDateFrom: '' + e.target.value,
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    const scrubbedValue = this.state.searchValue && this.state.searchType === 'CognitoUsername' && this.state.searchValue.charAt(0) === '+'
        ? '+' + this.state.searchValue.replace(/\D/g,'')
        : this.state.searchValue;

    await this.setState({searchValue:scrubbedValue})

    this.props.onSubmit(this.state);
  }

  render() {
    return (
      <div>
        {/*<h6 className="bold">User Management Audit</h6>*/}
        <form onSubmit={this.handleSubmit}>
          <cs.TextInputdiv className="user-search-form" >
            <InputWrap>
              <label className="link-donor-info-block-title">{"Search..."}</label>
              <DropDownMenu
                className="input-wrap-dropdown"
                maxHeight="350"
                name="userSearchSite"
                title={this.state.metaSearchDisplay}
                list={metaSearchTypes}
                changeHandler={this.handleMetaDropdownChange}
              />
            </InputWrap>
            <InputWrap>
              <label className="link-donor-info-block-title">{" By..."}</label>
              <DropDownMenu
                className="input-wrap-dropdown"
                name="userSearchType"
                title={this.state.searchDisplay}
                list={searchTypes}
                changeHandler={this.handleSearchTypeChange}
                doFixForFocusNotHiding={true}
              />
            </InputWrap>

            {['ShowAll', 'DateCreated','DateUpdated', 'LastLogin'].indexOf(this.state.searchType) === -1 &&
              <OperatorWrapper>=</OperatorWrapper>}

            {['CognitoUsername', 'ShowAll', 'DateCreated','DateUpdated', 'LastLogin'].indexOf(this.state.searchType) === -1 &&
              <InputWrap key={this.state.searchType}>
                <label className="link-donor-info-block-title">&nbsp;</label>
                  <forms.ClearableInput
                  width="100%"
                  type="text"
                  name={this.state.searchFieldName}
                  onChange={this.handleSearchFieldChange} />
              </InputWrap>}

            {this.state.searchType === 'CognitoUsername' &&
              <InputWrap key={this.state.searchType}>
                <label className="link-donor-info-block-title">&nbsp;</label>
                  <EmailPhoneToggle onChange={this.handleSearchFieldChange}/>
              </InputWrap>}

            {['DateCreated','DateUpdated', 'LastLogin'].indexOf(this.state.searchType) > -1 &&
              <>
                <InputWrap key={this.state.searchType+'From'}>
                <label className="link-donor-info-block-title">From: (blank = beginning)</label>
                  <forms.ClearableInput
                  width="100%"
                  type="text"
                  name={this.state.searchFieldName+'From'}
                  placeholder={"m/d/yyyy"}
                  onChange={this.handleFromDateFieldChange} />
                </InputWrap>
                <InputWrap key={this.state.searchType+'To'}>
                  <label className="link-donor-info-block-title">To: (blank = now)</label>
                  <forms.ClearableInput
                  width="100%"
                  type="text"
                  placeholder={"m/d/yyyy"}
                  name={this.state.searchFieldName+'To'}
                  onChange={this.handleToDateFieldChange} />
                </InputWrap>
              </>}

            <ButtonWrap>
              <br/>
              <FilledYellow
                width="7.0625rem"
                bgColor={"#FFD100"}
                fontColor={"#005587"}
                borderColor={"#FFD100"}
                name={"filterUserSearchResults"}
              >
                <span> Search</span>
              </FilledYellow>
            </ButtonWrap>
          </cs.TextInputdiv>
        </form>
      </div>
    )
  }
}

export default SharedQueryForm;